import { ChangeEvent, useState } from "react";

export type RangeDateValue = { from: string; until: string };

type RangeDateFilterProps = {
  onChange: (data: RangeDateValue) => void;
  defaultValue?: RangeDateValue;
};

export const RangeDateFilter = ({
  onChange,
  defaultValue
}: RangeDateFilterProps) => {
  const [startDate, setStartDate] = useState(defaultValue?.from || "");
  const [endDate, setEndDate] = useState(defaultValue?.until || "");

  const handleStartDateChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newStartDate = e.target.value;
    setStartDate(newStartDate);

    let updatedToDate = endDate;

    if (endDate && newStartDate > endDate) {
      updatedToDate = newStartDate;
      setEndDate(updatedToDate);
    }

    onChange({
      from: newStartDate,
      until: updatedToDate
    });
  };

  const handleEndDateChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newEndDate = e.target.value;
    setEndDate(newEndDate);

    onChange({
      from: startDate,
      until: newEndDate
    });
  };

  return (
    <div className="flex gap-2 min-h-0 mt-3">
      <div className="space-y-3">
        <span className="text-sm font-bold">From</span>
        <div className="space-y-2">
          <input
            type="date"
            value={startDate}
            onChange={handleStartDateChange}
            className="w-full h-[40px] px-3 border border-gainsboro rounded-md text-sm"
            aria-label="From Date"
          />
        </div>
      </div>

      <div className="space-y-3">
        <span className="text-sm font-bold">Until</span>
        <div className="space-y-2">
          <input
            type="date"
            value={endDate}
            min={startDate || undefined}
            onChange={handleEndDateChange}
            className="w-full h-[40px] px-3 border border-gainsboro rounded-md text-sm"
            aria-label="To Date"
          />
        </div>
      </div>
    </div>
  );
};
